import React, { useMemo, useState } from 'react';
import { Stack, Chip, IconButton, TextField, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const toISODate = (d) =>
  dayjs(d).isValid() ? dayjs(d).startOf('day').toISOString() : null;

export function MultiDatePicker({ label = 'Deadlines', value, onChange }) {
  const [draft, setDraft] = useState(null);

  const sorted = useMemo(() => {
    const raw = Array.isArray(value) ? value : (value ? [value] : []);
    const arr = raw
      .map(v => dayjs(v))
      .filter(d => d.isValid())
      .sort((a, b) => a.valueOf() - b.valueOf());

    const seen = new Set();
    return arr.filter(d => {
      const k = d.format('YYYY-MM-DD');
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  }, [value]);

  const add = () => {
    if (!dayjs(draft).isValid()) return;
    const iso = toISODate(draft);
    if (!iso) return;

    const raw = Array.isArray(value) ? value : (value ? [value] : []);
    onChange([...raw, iso]);
    setDraft(null);
  };

  const remove = (idx) => {
    const next = sorted.map(d => toISODate(d)).filter(Boolean);
    next.splice(idx, 1);
    onChange(next);
  };

  return (
    <Stack spacing={1}>
      <Stack direction="row" spacing={1} alignItems="center">
        <DatePicker
          label={label}
          value={draft}
          onChange={setDraft}
          renderInput={(params) => (
            <TextField {...params} size="small" fullWidth />
          )}
        />

        <Tooltip title="Add date">
          <span>
            <IconButton onClick={add} disabled={!dayjs(draft).isValid()}>
              <AddIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Stack>

      <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
        {sorted.length === 0 ? (
          <TextField size="small" value="" placeholder="No deadlines added" disabled fullWidth />
        ) : (
          sorted.map((d, i) => (
            <Chip
              key={d.format('YYYY-MM-DD')}
              label={d.format('MM/DD/YYYY')}
              onDelete={() => remove(i)}
              size="small"
              variant="outlined"
              sx={{ mb: 1 }}
            />
          ))
        )}
      </Stack>
    </Stack>
  );
}
